exports.reports_sections = {
	PROGRAMMING: 'programming',
	MCQ: 'mcq',
	QUIZ: 'quiz',
	PROJECT: 'project',
	SQL: 'sql',
	WEB: 'web',
	CONTEST: 'contest'
}

exports.candidate_types = {
	FRESHER: 'FRESHER'
}

exports.onboard_options = {
	ACADEMY: 'academy',
	COMPANY: 'company',
	ATS: 'ATS'
}


// WEBPACK FOOTER //
// ./src/app/utils/enums.js